export default __webpack_public_path__ + "static/client-details-2-812a2a00d852d2a3c1826883100db558.png";